import WorkflowSetupDetails from "./WorkflowSetupDetails";

export default WorkflowSetupDetails;